/* eslint-disable */
import React from 'react';

import StageContent from "./StageContent"
const AccordionItemData = (props) => {
  let stageState = props.isPast === true ? "past" : "active";
    return (
        <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title">
            <a className="accordionItemHead" data-toggle="collapse" data-parent="#accordion" href={'#stage_'+stageState+props.itemKey} >{props.title}</a>
          </h4>
        </div>
        <StageContent stageCode={props.stageCode} currentStageData={props.stageData} allStageConfigData={props && props.stageConfigData} advertisementDetails={props.advertisementDetailsData}  stageId={props.itemKey} adverId={props.advertisementId} isPast={stageState}/>
        </div>
       
      
    )
}

export default AccordionItemData;
